/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import { Field } from "@atlaskit/form";
import Modal, { ModalTransition, ModalFooter } from "@atlaskit/modal-dialog";
import ButtonGroup from "@atlaskit/button/button-group";
import Button from "@atlaskit/button/custom-theme-button";
import useAsync from "../../hooks/use-async";
import apiClient from "../../api/admin-api-client";
import SectionMessage from "@atlaskit/section-message";
import styled from "styled-components";
import { toast } from "react-toastify";
import TextArea from "@atlaskit/textarea";
import useAdminDocumentType from "../../hooks/use-admin-document-type";
import { useTranslation } from "react-i18next";

export default function ConfigModal({ onClose, onSuccess, documentTypeId }) {
    const { documentType, isPending: isPendingDocumentType } = useAdminDocumentType(documentTypeId);
    const { run, isPending, error, isError: isCreatingError } = useAsync();
    const [ config, setConfig ] = useState(documentType?.config);
    const { t } = useTranslation();

    useEffect(() => {
        setConfig(documentTypeId?.config);
    }, [ documentType?.id ]);

    const footer = (props) => (
        <ModalFooter showKeyline={props.showKeyline}>
            <ButtonGroup>
                <Button appearance="primary" type="button" isLoading={isPending || isPendingDocumentType} onClick={handleSubmit}>
                    {t("config_modal_save")}
                </Button>
                <Button type="button" isDisabled={isPending} onClick={onClose}>
                    {t("config_modal_cancel")}
                </Button>
            </ButtonGroup >
        </ModalFooter>
    );

    const handleSubmit = () => {
        run(apiClient(`document-types/${documentTypeId}`, { data: {
            config,
        }, method: "PATCH" }))
            .then(() => {
                toast.success(t("config_modal_success"));
                onSuccess();
            })
            .catch(() => {
                toast.error(t("config_modal_error"));
            });
    };

    return <ModalTransition>
        <Modal
            onClose={onClose}
            heading={t("config_modal_heading")}
            scrollBehavior="inside-wide"
            components={{
                Footer: footer,
            }}
        >
            {isCreatingError && <SectionMessageWrapper>
                <SectionMessage title={t("config_modal_error_heading")} appearance="error">
                    <p>{error?.message}</p>
                    {error?.errors && <ul>
                        {Object.keys(error.errors).map(key => (
                            <li key={key}>{error.errors[key]}</li>
                        ))}
                    </ul>}
                    <code>
                        {JSON.stringify(error)}
                    </code>
                </SectionMessage>
            </SectionMessageWrapper>}
            <Field name="config" label={t("config_modal_config")} isRequired autoFocus isDisabled={isPending}>
                {({ fieldProps }) => <TextArea
                    {...fieldProps}
                    isMonospaced
                    isDisabled={isPendingDocumentType}
                    value={config}
                    onChange={e => setConfig(e?.target?.value)}
                    minimumRows={5}
                />}
            </Field>
        </Modal>
    </ModalTransition>;
}

const SectionMessageWrapper = styled.div`
    margin-top: 0px;
    font-size: 13px;
`;

